module.exports = __webpack_public_path__ + "static/media/dissect_s.a4dc365a.jpg";